import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollTop({ dependency }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.getElementById("root").scrollIntoView({ behavior: "smooth" });
  }, [pathname, dependency]);

  return null;
}

export default ScrollTop;
